import React, { useState, useEffect } from 'react';

const SearchableSelect = ({ options, value, onChange, disabled, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const wrapperRef = React.useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [wrapperRef]);

  const selectedOption = options.find(o => o.value === value);
  const displayValue = isOpen ? search : (selectedOption ? (selectedOption.label || selectedOption.value) : '');

  const filteredOptions = options.filter(o =>
    (o.label || '').toLowerCase().includes(search.toLowerCase()) ||
    (o.value || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="relative w-full" ref={wrapperRef}>
      <div
        className={`w-full border rounded p-2 focus-within:ring-2 focus-within:ring-primary flex items-center bg-white ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-50' : 'cursor-text'}`}
        onClick={() => {
          if (!disabled && !isOpen) {
            setIsOpen(true);
            setSearch('');
          }
        }}
      >
        <input
          type="text"
          className="w-full outline-none bg-transparent"
          placeholder={isOpen ? placeholder : (selectedOption ? (selectedOption.label || selectedOption.value) : placeholder)}
          value={displayValue}
          disabled={disabled}
          onChange={(e) => {
            if (!disabled) {
              setSearch(e.target.value);
              setIsOpen(true);
            }
          }}
          onFocus={() => {
            if (!disabled && !isOpen) {
              setIsOpen(true);
              setSearch('');
            }
          }}
        />
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border rounded shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.length === 0 ? (
            <div className="p-2 text-gray-500 text-sm">No results found</div>
          ) : (
            filteredOptions.map((option, idx) => (
              <div
                key={option.value || idx}
                className={`p-2 hover:bg-fuchsia-50 cursor-pointer text-sm ${option.value === value ? 'bg-fuchsia-100 font-medium text-primary' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onChange(option.value);
                  setIsOpen(false);
                  setSearch('');
                }}
              >
                {option.label || option.value || '—'}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
